import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
export default function DeleteCompatibleProductProductDialog(props) {

  const componentConstants = {
    ...props.componentConstants
  }

  const componentMethods = {
    ...props.componentMethods
  }

  const handleClose = () => {
    componentMethods.setOpenDeleteCompatibleProductsProduct(false, null)
  };

  return (
    <div>
      <Dialog
        open={props.openDeleteDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{componentConstants.language.LANG_DELETE_COMPATIBLE_PRODUCT_PRODUCT_MESSAGE_TITLE}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {componentConstants.language.LANG_DELETE_COMPATIBLE_PRODUCT_PRODUCT_MESSAGE}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
          {componentConstants.language.LANG_CANCEL}
          </Button>
          <Button onClick={(e) => { componentMethods.deleteCompatibleProductsProduct(); handleClose()}} color="secondary" variant="contained" autoFocus>
          {componentConstants.language.LANG_DELETE}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}